module.exports = __webpack_public_path__ + "img/certification-comercam.1cc53957.png";